
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDeviceFilter as ObiDeviceFilterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-device-filter.js';
 
 
 

 
 export const ObiDeviceFilter = createComponent({
   react: React,
   tagName: 'obi-device-filter',
   elementClass: ObiDeviceFilterElement,
   events: {
     
   }
  });
 
 